
const TYPE_W = 'w'
const TYPE_K = 'k'
const allKeyboardKeysRegex = /[^\u0021-\u007E]/g // 僅 英文+數字+ 鍵盤上的符號

export default {

  methods: {
    /**
     *
     * @param {string} dataKey : key of data (model)
     */
    $f2hHandler (dataKey, type) {
      if (!dataKey) { return }
      this[dataKey] = this.fullToHalf(this[dataKey])
      if (this[dataKey]) {
        if (type === TYPE_W) {
          this[dataKey] = this[dataKey].toUpperCase() // 小寫轉大寫
        } else if (type === TYPE_K) {
          this[dataKey] = this[dataKey].replace(allKeyboardKeysRegex, '') // 僅保留 英文+數字+ 鍵盤上的符號
        }
      }
    },
    /**
     * 全形字串轉半形字串
     * @param {*} item 原始字串資料
     */
    fullToHalf (item) {
      if (!item) {
        return item
      }
      let half = ''
      for (var i = 0; i < item.length; i++) {
        var charCode = item.charCodeAt(i)
        if (charCode === 12288) {
          half += ''
        } else {
          if (charCode > 65280 && charCode < 65375) {
            half += String.fromCharCode(charCode - 65248)
          } else {
            half += String.fromCharCode(charCode)
          }
        }
      }
      return half
    },
    /**
     * 半形字串轉全形字串
     * @param {*} item 原始字串資料
     */
    halfToFull (item) {
      if (item) {
        const reg = /[0-9]+/g // 判斷
        let full = ''
        if (reg.exec(item) != null) {
          for (var i = 0; i < item.toString().length; i++) {
            let charCode = item.toString().charCodeAt(i)
            if (charCode <= 126 && charCode >= 33) {
              charCode += 65248
            } else if (charCode === 32) {
            // 半形空白轉全形
              charCode = 12288
            } else if (charCode === 8211 || charCode === 8212) {
              // 全形標點符號連結號(有兩個)轉全形 －
              charCode = 65293
            }
            full = full + String.fromCharCode(charCode)
          }
          return full
        } else {
          return item
        }
      }
      return item
    },
    number (v, { toHalf = true } = {}) {
      if (!v) return v
      if (toHalf) {
        v = this.fullToHalf(v)
      }
      const r = Array.from(v).filter(num => {
        return !isNaN(num) && num !== ' '
      })
      return r.join('')
    }
  }
}
